var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page--gradient-background"},[_c('section',{staticClass:"aml"},[(_vm.isLoading)?_c('loader'):_c('aml-questionnaire',{attrs:{"refreshUserDetails":"","cancelRoute":_vm.routeToHome,"redirecTo":_vm.routeToHome}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }